import { Observable } from "rxjs";
import { ObservableFromFetch } from "../ObservableFromFetch"

interface PoolCloseProgramYearSaveOptions {
  PoolID: number
  SelectionInterval?: string
  AlcoholTarget?: number
  DrugTarget?: number
  PanelID: number
  ProviderMappingID: number
  DateFrom: string
  DateTo: string
}

export default function CloseProgramIntervalObservable(data: PoolCloseProgramYearSaveOptions): Observable<string> {
  const params: string = JSON.stringify(data)
  return ObservableFromFetch<string>("FFOrderPoolDefinition/CloseProgramInterval", params)
}
